/* src/app/tip-ticket/pages/tip-tickets/tip-tickets.component.scss */
/*# sourceMappingURL=tip-tickets.component.css.map */
